import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16",
  fillRule: "evenodd"
});

var SvgChevronLeftMinor = function SvgChevronLeftMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgChevronLeftMinor as S };
